// src/services/finance/invoice.service.js
import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}invoices/`;

export default {
  getAll(params = {}) {
    return axios.get(API_URL, { params, headers: buildHeaders() });
  },

  get(id) {
    return axios.get(`${API_URL}${id}`, { headers: buildHeaders() });
  },

  create(data) {
    return axios.post(API_URL, data, { headers: buildHeaders() });
  },

  update(id, data) {
    return axios.put(`${API_URL}${id}`, data, { headers: buildHeaders() });
  },

  delete(id) {
    return axios.delete(`${API_URL}${id}`, { headers: buildHeaders() });
  },

  stats(params = {}) {
    return axios.get(`${API_URL}stats`, { params, headers: buildHeaders() });
  },

  nextNumber() {
    return axios.get(`${API_URL}next-number`, { headers: buildHeaders() });
  },

  // receivePayment(id, payload) {
  //   return axios.post(`${API_URL}${id}/receive-payment`, payload);
  // },

  // NEW: time-series for chart

  receivePayment(id, payload) {
    return axios.post(`${API_URL}${id}/receive-payment`, payload, {
      headers: buildHeaders(),
    });
  },

  series(params = {}) {
    return axios.get(`${API_URL}report-series`, {
      params,
      headers: buildHeaders(),
    });
  },

  // NEW: export PDF
  exportPdf(params = {}) {
    return axios.get(`${API_URL}export-pdf`, {
      params,
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  // NEW: export Excel
  exportExcel(params = {}) {
    return axios.get(`${API_URL}export-excel`, {
      params,
      headers: buildHeaders(),
      responseType: "blob",
    });
  },
};
